
import React from 'react';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Features as FeaturesSection } from '@/components/Features';
import { useLanguage } from '@/contexts/LanguageContext';

const Features = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 container py-8 mt-16">
        <div className="mb-8 text-center">
          {/*<h1 className="text-4xl font-bold">{t('features.title')}</h1>*/}
          {/*<p className="text-muted-foreground mt-2">
            {t('features.subtitle')}
          </p>*/}
        </div>
        
        <FeaturesSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default Features;
